{
  "familyId": "GET-BREUK-MIN",
  "questions": [
    {
      "id": "GET-BREUK-MIN-001",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{5}{6}$ - $\\frac{2}{6}$ =",
      "options": ["$\\frac{3}{6}$", "$\\frac{3}{12}$", "$\\frac{7}{6}$", "$\\frac{5}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 5, "denominator": 6, "label": "5/6"},
              {"numerator": 2, "denominator": 6, "label": "2/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "5/6 - 2/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij gelijknamige breuken trek je alleen de tellers van elkaar af — de noemer blijft hetzelfde. Tellers: 5 - 2 = 3. De noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$. Controleer: $\\frac{3}{6}$ + $\\frac{2}{6}$ = $\\frac{5}{6}$ ✓.",
        "solutionSteps": [
          "Controleer: de noemers zijn gelijk (beide 6) → gelijknamige breuken",
          "Trek de tellers af: 5 - 2 = 3",
          "De noemer blijft 6",
          "Antwoord: $\\frac{3}{6}$",
          "Controleer: $\\frac{3}{6}$ + $\\frac{2}{6}$ = $\\frac{5}{6}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 5 - 2 = 3, noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (6 + 6 = 12). Maar bij gelijknamige breuken blijft de noemer hetzelfde — je trekt alleen de tellers af. Onthoud: de noemer verandert niet bij gelijknamig aftrekken.",
          "2": "Je hebt de tellers opgeteld (5 + 2 = 7) in plaats van afgetrokken. Let op het minteken: 5 - 2 = 3, niet 5 + 2 = 7. Onthoud: bij aftrekken wordt het antwoord kleiner.",
          "3": "Je hebt de tweede breuk niet afgetrokken en de eerste breuk als antwoord gegeven. Trek de tellers af: 5 - 2 = 3. Onthoud: je moet de bewerking uitvoeren."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-002",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{7}{8}$ - $\\frac{3}{8}$ =",
      "options": ["$\\frac{4}{8}$", "$\\frac{4}{16}$", "$\\frac{10}{8}$", "$\\frac{3}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_eighths",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 7, "denominator": 8, "label": "7/8"},
              {"numerator": 3, "denominator": 8, "label": "3/8"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 8,
            "label": "7/8 - 3/8 = 4/8",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij gelijknamige breuken trek je alleen de tellers af. Tellers: 7 - 3 = 4. De noemer blijft 8. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$. Tip: $\\frac{4}{8}$ kun je vereenvoudigen tot $\\frac{1}{2}$.",
        "solutionSteps": [
          "Controleer: de noemers zijn gelijk (beide 8) → gelijknamige breuken",
          "Trek de tellers af: 7 - 3 = 4",
          "De noemer blijft 8",
          "Antwoord: $\\frac{4}{8}$ (= $\\frac{1}{2}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 7 - 3 = 4, noemer blijft 8. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook optelt (8 + 8 = 16). Maar bij gelijknamige breuken blijft de noemer hetzelfde. Onthoud: alleen de tellers veranderen, de noemer niet.",
          "2": "Je hebt de tellers opgeteld (7 + 3 = 10) in plaats van afgetrokken. Let op het minteken: 7 - 3 = 4, niet 7 + 3 = 10. Onthoud: bij aftrekken wordt het antwoord kleiner.",
          "3": "Je hebt per ongeluk de tweede breuk als antwoord gegeven in plaats van het verschil te berekenen. Trek de tellers af: 7 - 3 = 4. Onthoud: voer de bewerking uit."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-003",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{2}$ - $\\frac{1}{4}$ =",
      "options": ["$\\frac{1}{4}$", "$\\frac{0}{2}$", "$\\frac{2}{6}$", "$\\frac{1}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_unlike_fractions_basic",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 2, "label": "1/2"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "1/2 = 2/4, dan 2/4 - 1/4 = 1/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (2 en 4), dus je moet ze eerst gelijknamig maken. $\\frac{1}{2}$ = $\\frac{2}{4}$ (teller en noemer ×2). Nu kun je aftrekken: $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Controleer: $\\frac{1}{4}$ + $\\frac{1}{4}$ = $\\frac{2}{4}$ = $\\frac{1}{2}$ ✓.",
        "solutionSteps": [
          "De noemers zijn ongelijk (2 en 4) → maak ze gelijknamig",
          "$\\frac{1}{2}$ = $\\frac{2}{4}$ (teller en noemer ×2)",
          "Trek de tellers af: 2 - 1 = 1",
          "Antwoord: $\\frac{1}{4}$",
          "Controleer: $\\frac{1}{4}$ + $\\frac{1}{4}$ = $\\frac{2}{4}$ = $\\frac{1}{2}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$.",
          "1": "Je hebt 1 - 1 = 0 berekend zonder de noemers gelijk te maken. De noemers zijn ongelijk: maak ze eerst gelijk. $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Onthoud: bij ongelijke noemers eerst gelijknamig maken.",
          "2": "Je hebt de noemers opgeteld (2 + 4 = 6). Dat mag niet bij breuken aftrekken. Maak de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Onthoud: noemers optellen is nooit correct.",
          "3": "Je hebt de noemers vermenigvuldigd (2 × 4 = 8). Dat is niet de juiste aanpak. Maak de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$. Onthoud: zoek de kleinste gemeenschappelijke noemer."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-004",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "fill_in",
      "question": "Reken uit: $\\frac{2}{3}$ − $\\frac{1}{6}$ = ?",
      "context": null,
      "data": {
        "expectedAnswer": "3/6",
        "acceptedAnswers": ["3/6", "1/2", "$\\frac{3}{6}$", "$\\frac{1}{2}$"],
        "placeholder": "bv. 3/6",
        "unit": ""
      },
      "options": [],
      "correctAnswer": "3/6",
      "conceptId": "subtract_unlike_fractions_thirds",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 2, "denominator": 3, "label": "2/3" },
              { "numerator": 1, "denominator": 6, "label": "1/6" }
            ],
            "operator": "-",
            "visualType": "bar"
          },
          "a11y": { "alt": "Strookmodel met 2/3 boven en 1/6 eronder; de breuken hebben verschillende verdelingen." }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ongelijknamig aftrekken — maak gelijk",
            "content": "De noemers 3 en 6 zijn ongelijk. Zet $\\frac{2}{3}$ om naar zesden: $\\frac{2}{3} = \\frac{4}{6}$. Dan: $\\frac{4}{6} - \\frac{1}{6} = \\frac{3}{6}$ (= $\\frac{1}{2}$).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn ongelijk (3 en 6). Maak ze gelijk: $\\frac{2}{3} = \\frac{4}{6}$ (teller en noemer ×2). Trek de tellers af: 4 − 1 = 3. Antwoord: $\\frac{3}{6}$ (kan ook geschreven worden als $\\frac{1}{2}$). Controleer: $\\frac{3}{6} + \\frac{1}{6} = \\frac{4}{6} = \\frac{2}{3}$ ✓.",
        "solutionSteps": [
          "Noemers ongelijk (3 en 6) → maak gelijknamig",
          "$\\frac{2}{3} = \\frac{4}{6}$ (×2 boven en onder)",
          "Trek de tellers af: 4 − 1 = 3",
          "Antwoord: $\\frac{3}{6}$ = $\\frac{1}{2}$",
          "Check: $\\frac{3}{6} + \\frac{1}{6} = \\frac{4}{6} = \\frac{2}{3}$ ✓"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-BREUK-MIN-005",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "fill_in",
      "question": "Een kok heeft $\\frac{3}{4}$ kilo bloem. Hij gebruikt $\\frac{1}{3}$ kilo voor een recept. Hoeveel bloem heeft hij over? (geef je antwoord als breuk met noemer 12)",
      "context": null,
      "data": {
        "expectedAnswer": "5/12",
        "acceptedAnswers": ["5/12", "$\\frac{5}{12}$"],
        "placeholder": "bv. 5/12",
        "unit": "kilo"
      },
      "options": [],
      "correctAnswer": "5/12",
      "conceptId": "subtract_unlike_fractions_context",
      "variantIndex": 5,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 3, "denominator": 4, "label": "3/4 kilo" },
              { "numerator": 1, "denominator": 3, "label": "1/3 kilo" }
            ],
            "operator": "-",
            "visualType": "bar"
          },
          "a11y": { "alt": "Strookmodel met 3/4 (kwarten) en 1/3 (derden) — verschillende verdelingen die gelijknamig gemaakt moeten worden." }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoek de kleinste gemeenschappelijke noemer",
            "content": "Voor 4 en 3 is de kgn 12. $\\frac{3}{4} = \\frac{9}{12}$ (×3) en $\\frac{1}{3} = \\frac{4}{12}$ (×4). Trek af: $\\frac{9}{12} - \\frac{4}{12} = \\frac{5}{12}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De noemers zijn 4 en 3 — de kleinste gemeenschappelijke noemer is 12. $\\frac{3}{4} = \\frac{9}{12}$ (×3) en $\\frac{1}{3} = \\frac{4}{12}$ (×4). Trek af: $\\frac{9}{12} - \\frac{4}{12} = \\frac{5}{12}$. De kok heeft $\\frac{5}{12}$ kilo bloem over.",
        "solutionSteps": [
          "Noemers 4 en 3 → kleinste gemeenschappelijke noemer is 12",
          "$\\frac{3}{4} = \\frac{9}{12}$ (×3)",
          "$\\frac{1}{3} = \\frac{4}{12}$ (×4)",
          "Trek tellers af: 9 − 4 = 5",
          "Antwoord: $\\frac{5}{12}$ kilo"
        ]
      },
      "pedagogy": { "dok": 3 }
    },
    {
      "id": "GET-BREUK-MIN-SS-001",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "step_solver",
      "question": "Los stap voor stap op: $\\frac{5}{6} - \\frac{1}{4}$",
      "context": null,
      "data": {
        "stepSolver": {
          "problem": "$\\frac{5}{6} - \\frac{1}{4}$",
          "steps": [
            {
              "prompt": "Stap 1 — Wat is de kleinste gemeenschappelijke noemer van 6 en 4?",
              "answer": "12",
              "acceptedAnswers": ["12"],
              "hint": "Zoek het kleinste getal waar zowel 6 als 4 in passen. 6 × 2 = 12 en 4 × 3 = 12."
            },
            {
              "prompt": "Stap 2 — Schrijf $\\frac{5}{6}$ met noemer 12. Wat is de nieuwe teller?",
              "answer": "10",
              "acceptedAnswers": ["10"],
              "hint": "Vermenigvuldig teller en noemer met 2: 5 × 2 = 10, 6 × 2 = 12."
            },
            {
              "prompt": "Stap 3 — Schrijf $\\frac{1}{4}$ met noemer 12. Wat is de nieuwe teller?",
              "answer": "3",
              "acceptedAnswers": ["3"],
              "hint": "Vermenigvuldig teller en noemer met 3: 1 × 3 = 3, 4 × 3 = 12."
            },
            {
              "prompt": "Stap 4 — Trek de tellers af. Wat is de teller van het antwoord?",
              "answer": "7",
              "acceptedAnswers": ["7"],
              "hint": "10 − 3 = 7. De noemer blijft 12."
            },
            {
              "prompt": "Stap 5 — Geef het eindantwoord als breuk.",
              "answer": "7/12",
              "acceptedAnswers": ["7/12", "$\\frac{7}{12}$"],
              "hint": "Teller 7, noemer 12. Antwoord: $\\frac{7}{12}$."
            }
          ]
        }
      },
      "options": [],
      "correctAnswer": "7/12",
      "conceptId": "subtract_unlike_fractions_stepwise",
      "variantIndex": 6,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.76,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 5, "denominator": 6, "label": "5/6" },
              { "numerator": 1, "denominator": 4, "label": "1/4" }
            ],
            "operator": "-",
            "visualType": "bar"
          },
          "a11y": { "alt": "Strookmodel met 5/6 en 1/4 in twee verschillende verdelingen." }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan: ongelijknamig aftrekken",
            "content": "1) Zoek kgn. 2) Beide breuken omschrijven. 3) Tellers aftrekken. 4) Noemer blijft gelijk. 5) Vereenvoudig indien mogelijk.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap voor stap: kgn van 6 en 4 = 12. $\\frac{5}{6} = \\frac{10}{12}$ en $\\frac{1}{4} = \\frac{3}{12}$. Trek af: $\\frac{10}{12} - \\frac{3}{12} = \\frac{7}{12}$. $\\frac{7}{12}$ is al in eenvoudigste vorm (7 is priem).",
        "solutionSteps": [
          "Kgn van 6 en 4 = 12",
          "$\\frac{5}{6} = \\frac{10}{12}$ (×2)",
          "$\\frac{1}{4} = \\frac{3}{12}$ (×3)",
          "Tellers: 10 − 3 = 7",
          "Antwoord: $\\frac{7}{12}$"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}